<span class="badge badge-pedido-status badge-pedido-status-faturado-parcial">
    {{status.nome}}
</span>